<template>
  <div class="main">
    <back class="back-page" useDefaultBack @backLastPage="backLastPage"/>
    <el-tabs v-model="activeName" class="records">
      <el-tab-pane label="付费记录" name="paymentRecord"></el-tab-pane>
      <el-tab-pane v-if="!($route.query.shop_type === 'old_ls')" label="开票记录" name="invoiceRecord"></el-tab-pane>
    </el-tabs>
    <component :is="activeName"></component>
  </div>
</template>

<script>
import paymentRecord from "./components/paymentRecord";
import invoiceRecord from "./components/invoiceRecord";
import domain from '@/config/subSystem-domain';

export default {
  data() {
    return {
      activeName: "paymentRecord",
      shopID: 0, // 店铺ID
      shopType: "", // 店铺类型
      shopName: "", // 店铺名称
    };
  },

  created() {
    this.init();
  },

  methods: {
    init() {
      this.shopID = this.$route.query.shop_id;
      this.shopType = this.$route.query.shop_type;
      this.shopName = this.$route.query.shop_name;
    },

    backLastPage() {
      if(this.shopType === 'new_ls') {
        window.location.href = domain.new_retail_domain + '/admin/#/main/configuration/nav/shopInfo=' + this.shopID;
      }
    },
  },
  components: {
    paymentRecord,
    invoiceRecord
  }
};
</script>

<style lang="scss" scoped>
/deep/ .is-active {
  font-weight: 600;
}

/deep/ .el-tabs {
  .el-tabs__header {
    margin: 0;
  }

  .el-tabs__content{
    height: calc(100% - 40px);
  }
  
  .el-tab-pane {
    height: 100%;
    padding: 14px 0 0;
  }
}

.main {
  position: relative;
  width: 1080px;
  min-height: 660px;
  height: calc(100vh - 140px);
  margin: 0 auto;
  padding: 0 0 10px 0;
  border-radius: 8px;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
  background: #ffffff;

  .back-page {
    padding: 6px 30px;
    border-radius: 8px;
  }
  
  .el-tabs {
    width: 1020px;
    margin: 0 auto;
  }
}
</style>